var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index_page"},[_c('top-bar'),_c('transition',{attrs:{"name":"fade_transition","mode":"out-in"}},[_c('router-view')],1),_c('Footer'),_c('floating-group')],1)}
var staticRenderFns = []

export { render, staticRenderFns }